import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import AdvancesDeclines from '../../pages/markets/component/advances-declines';

export const AdvancesDeclinesWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <AdvancesDeclines widget={true} />
    </QueryClientProvider>
  );
};
